var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonChimeSdk32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Chime-SDK_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Chime-SDK_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Chime-SDK_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,20.809 L14.276,19.949 C14.107,19.865 14,19.691 14,19.502 L14,19.49 L12,19.49 L12,18.49 L14,18.49 L14,17.786 L11.038,16.077 L10,16.76 L10,19.248 L12.343,21.109 L11.72,21.892 L9.188,19.881 C9.069,19.786 9,19.642 9,19.489 L9,16.732 L8.052,16.079 L5,17.794 L5,19.18 L6.475,19.917 L7.723,19.085 L8.277,19.917 L7,20.768 L7,21.975 C7,22.142 6.916,22.298 6.777,22.391 L5.277,23.391 L4.723,22.559 L6,21.707 L6,20.798 L4.497,20.047 L3,20.824 L3,24.185 L4.722,25.038 C4.893,25.122 5,25.296 5,25.486 L5,27.202 L5.349,27.402 L7.555,25.292 L8.246,26.015 L6.253,27.921 L7.995,28.921 L9,28.236 L9,26 L9,25 L9,23.747 L7.87,22.885 L8.476,22.09 L9.803,23.102 C9.927,23.196 10,23.344 10,23.499 L10,25 L12,25 L12,26 L10,26 L10,28.241 L11.032,28.915 L14,27.211 L14,25.496 C14,25.307 14.106,25.134 14.275,25.049 L14.679,24.847 L13.15,23.352 L13.85,22.638 L15.622,24.371 L16,24.181 L16,20.809 Z M17,20.5 L17,24.489 C17,24.678 16.894,24.851 16.725,24.936 L15,25.804 L15,27.501 C15,27.68 14.904,27.846 14.749,27.934 L11.265,29.934 C11.188,29.979 11.102,30.001 11.016,30.001 C10.92,30.001 10.825,29.974 10.742,29.919 L9.498,29.107 L8.299,29.923 C8.214,29.981 8.116,30.01 8.018,30.01 C7.932,30.01 7.846,29.988 7.769,29.944 L4.251,27.925 C4.096,27.836 4,27.67 4,27.491 L4,25.796 L2.278,24.944 C2.107,24.859 2,24.685 2,24.496 L2,20.52 C2,20.333 2.104,20.162 2.27,20.076 L4,19.178 L4,17.502 C4,17.321 4.098,17.155 4.255,17.066 L7.833,15.054 C7.999,14.961 8.205,14.97 8.361,15.079 L9.521,15.878 L10.747,15.072 C10.905,14.969 11.109,14.962 11.271,15.057 L14.75,17.064 C14.904,17.153 15,17.318 15,17.497 L15,19.193 L16.724,20.053 C16.893,20.137 17,20.31 17,20.5 L17,20.5 Z M13,12 L14,12 L14,5 L13,5 L13,12 Z M16,13 L17,13 L17,7 L16,7 L16,13 Z M19,15 L20,15 L20,5 L19,5 L19,15 Z M25,10 L26,10 L26,7 L25,7 L25,10 Z M10,11 L11,11 L11,7 L10,7 L10,11 Z M22,12 L23,12 L23,7 L22,7 L22,12 Z M22.5,23.797 C22.44,23.797 22.38,23.786 22.321,23.764 C22.128,23.69 22,23.504 22,23.297 L22,19 L18,19 L18,18 L22.5,18 C22.776,18 23,18.224 23,18.5 L23,21.99 L25.532,19.166 C25.627,19.06 25.763,19 25.904,19 L27.635,19 C28.324,19 29,18.312 29,17.611 L29,4.281 C29,3.575 28.473,3 27.824,3 L8.219,3 C7.547,3 7,3.575 7,4.281 L7,14 L6,14 L6,4.281 C6,3.023 6.995,2 8.219,2 L27.824,2 C29.024,2 30,3.023 30,4.281 L30,17.611 C30,18.861 28.873,20 27.635,20 L26.128,20 L22.872,23.631 C22.775,23.739 22.64,23.797 22.5,23.797 L22.5,23.797 Z",
    id: "Fill-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonChimeSdk32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Chime-SDK_32.767126ff54fc911d4b21efd814fd41d8.svg";
export { ForwardRef as ReactComponent };